import Image from 'next/image'
import Link from 'next/link'
// Components
import styles from './Card.module.scss'

type CardProps = {
  slug: string
  title: string
  image: string
  readingTime?: string
  details?: boolean
}

export default function Card({
  slug,
  title,
  image,
  readingTime,
  details,
}: CardProps) {
  return (
    <div className={styles.card}>
      <Link href={`/blog/${slug}`} className={styles.action}>
        <div className={styles.image}>
          {image && (
            <Image
              width={254}
              height={169}
              src={image}
              alt={title}
              loading="lazy"
            />
          )}
        </div>
      </Link>

      <div className={styles.content}>
        <Link href={`/blog/${slug}`}>
          <p className={styles.title}>{title}</p>
        </Link>

        {details && !!readingTime && (
          <p className={styles.time}>{readingTime} read</p>
        )}
        {details && (
          <Link href={`/blog/${slug}`} className={styles.action}>
            Read article
          </Link>
        )}
      </div>
    </div>
  )
}
